import {
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { backendErrorsHandler } from '../../utils/Notification/BackendErrorsHandler';
import { createCashupReportV2, deleteCashupReportByIdV2 } from '../../services/cashup.service';
import type { ICashUpReport } from '../../interfaces/Store';
const listQueryKey = 'cashups';

export const useCreateCashupReport = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: {
      storeId: string;
      id: string;
      cashierBox: string;
      startingCash: number;
      declaredCash: number;
      declaredCard: number;
      declaredTransfer: number;
      declaredMercadoPago: number;
      cashToBank: number;
      notes: string;
    }) => {
      try {
        const res = await createCashupReportV2(data.storeId, data.id, {
          cashierBox: data.cashierBox,
          startingCash: data.startingCash,
          declaredCash: data.declaredCash,
          declaredCard: data.declaredCard,
          declaredTransfer: data.declaredTransfer,
          declaredMercadoPago: data.declaredMercadoPago,
          cashToBank: data.cashToBank,
          notes: data.notes
        });
        if (!res?.data?.data) {
          throw new Error('Oh no! Something went wrong while creating.');
        }
        return (res.data.cashUpReport as ICashUpReport | undefined) ?? null;
      } catch (e: any) {
        console.log('error caught', e['response']?.data?.['errors']);
        backendErrorsHandler(e);
        throw e;
      }
    },
    onSuccess: async () => {
      return Promise.all([queryClient.invalidateQueries({
        queryKey: [listQueryKey],
      })]);
    }
  });
};

export const useDeleteCashUpReportById = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (params: {
      storeId: string;
      id: string;
      cancellationReason?: string | null;
    }) => {
      try {
        const res = await deleteCashupReportByIdV2(params.storeId, params.id, {
          cancellationReason: params.cancellationReason ?? null
        });
        if (!res?.data?.data) {
          throw new Error('Oh no! Something went wrong while fetching.');
        }
        return res.data.data;
      } catch (e: any) {
        console.log('error caught', e['response']?.data?.['errors']);
        backendErrorsHandler(e);
        throw e;
      }
    },
    onSuccess: async () => {
      return Promise.all([queryClient.invalidateQueries({
        queryKey: [listQueryKey],
      })]);
    }
  });
};
